var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-test-id": "accessory" } },
    [
      _c(
        "div",
        {
          staticClass: "accessory-card",
          attrs: { id: _vm.id },
          on: { click: _vm.onCardClick },
        },
        [
          _c(
            "ob1-cards",
            {
              staticClass: "p-1",
              attrs: {
                "with-composite-link": false,
                "is-selected": _vm.isAdded,
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "accessory-card-promo-tag mt--1 float-start" },
                  [
                    _vm.currentVersion.banner
                      ? _c("ob1-tag", {
                          attrs: { label: _vm.currentVersion.banner },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "accessory-card-picture px-0 col-12 d-flex align-items-center",
                  },
                  [
                    _vm.currentVersion.pictures.length > 0
                      ? _c("img", {
                          staticClass: "accessory-card-picture-img",
                          attrs: {
                            alt: _vm.currentVersion.pictures[0].alt,
                            src: _vm.currentVersion.pictures[0].src,
                            srcset: _vm.currentVersion.pictures[0].xsSrcSet,
                          },
                        })
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "accessory-card-name col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "lead mt-2 mb-1",
                      attrs: { "data-writefontsize": "" },
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.accessoryTitle))])]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "accessory-card-versions col-12 pb-2" },
                  [
                    _vm.colors.length > 1 && !_vm.isAdded
                      ? _c(
                          "div",
                          [
                            _c("ob1-pastilles-de-couleurs", {
                              attrs: {
                                id: _vm.id + "-colors",
                                colors: _vm.colors,
                                "is-mini": true,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "accessory-card-price col-12" },
                  [
                    _c("ob1-prix-terminal", {
                      attrs: {
                        "multiple-price":
                          _vm.accessory.hasMultiplePrice && !_vm.isAdded,
                        "total-price-with-promo": _vm.priceWithPromo,
                        "total-price-without-promo": _vm.priceWithoutDiscount,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "accessory-card-advantage col-12 p-0" },
                  [
                    _c("advantage-bloc", {
                      attrs: {
                        "advantage-messages": _vm.advantageMessages,
                        discount: _vm.currentVersion.promoData
                          ? _vm.currentVersion.promoData.amountInCents
                          : null,
                        odr: _vm.currentVersion.odrData
                          ? _vm.currentVersion.odrData.amountInCents
                          : null,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "accessory-card-das col-12" },
                  [
                    _vm.accessory.das
                      ? _c("das-bundle-accessories", {
                          staticClass: "mb-1",
                          attrs: {
                            head: _vm.accessory.das.head,
                            limbs: _vm.accessory.das.member,
                            prefix: _vm.dasDto,
                            trunk: _vm.accessory.das.trunk,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "accessory-card-cta col-12" }, [
                  _c("div", { staticClass: "d-flex justify-content-center" }, [
                    _vm.isLoading
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "my-2" },
                            [
                              _c("ob1-progress-indicators", {
                                attrs: { size: 50, type: "undetermined" },
                              }),
                            ],
                            1
                          ),
                        ])
                      : !_vm.isAdded
                      ? _c(
                          "div",
                          [
                            _c("ob1-liens", {
                              staticClass: "mt-2",
                              attrs: {
                                "is-button": true,
                                "is-mini": false,
                                text: _vm.openCardButtonLabel,
                                "with-arrow": true,
                                "modal-id": _vm.popinId,
                                "data-bs-toggle": "modal",
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c("ob1-liens-icone", {
                              staticClass: "mt-2",
                              attrs: {
                                mini: false,
                                "prevent-default": true,
                                title: _vm.deleteButtonLabel,
                                icon: "icon-trash",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onRemoveButtonClick()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("accessory-popin", {
        attrs: {
          id: _vm.popinId,
          accessory: _vm.accessory,
          "display-version-id-seo": _vm.currentVersion.idSeo.value,
          "is-added": _vm.isAdded,
          "das-dto": _vm.dasDto,
          "compact-promo-messages-dto": _vm.compactPromoMessagesDto,
          "is-bundle": false,
        },
        on: {
          "accessory-add": _vm.onAccessoryAddButtonClick,
          "accessory-remove": _vm.onAccessoryDeleteButtonClick,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }